import Alpine from 'alpinejs'

Alpine.data('measure', function () {
  let state = Alpine.reactive({
    measured: false,
    width: 0,
    height: 0,
  })

  return {
    measured() {
      return state.measured
    },
    width() {
      return state.height
    },
    height() {
      return state.height
    },
    target: {
      'x-init'() {
        let resizeObserver = new ResizeObserver(entries => {
          let style = getComputedStyle(entries[0].target)
          let marginLeft = parseFloat(style.marginLeft)
          let marginRight = parseFloat(style.marginRight)
          let marginTop = parseFloat(style.marginTop)
          let marginBottom = parseFloat(style.marginBottom)

          let width = entries[0].contentRect.width + marginLeft + marginRight
          let height = entries[0].contentRect.height + marginTop + marginBottom

          state.width = width
          state.height = height
          state.measured = true
        })

        resizeObserver.observe(this.$el)
      },
    },
  }
})
